import React from 'react';
import styled from 'styled-components';
import { TextSMMedium, TextSMRegular } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { FollowButton } from 'components/FollowButton';
import { Link } from 'components/Link';
import { ProfileImage } from 'components/ProfileImage';
import { Spacing } from 'styleguide/spacing';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

interface UserCellProps {
  username: string;
  name?: string;
  profilePic?: string;
}

export const UserCell = ({ username, name, profilePic }: UserCellProps) => {
  return (
    <Link href={`/user/${username}`}>
      <Container>
        <ProfileImage source={profilePic} diameter={50} />
        <View style={{ flex: 1, justifyContent: 'center', marginLeft: Spacing.md }}>
          <TextSMMedium>{username}</TextSMMedium>
          {name && <TextSMRegular type="secondary">{name}</TextSMRegular>}
        </View>
        <FollowButton username={username} buttonStyle={{ fontWeight: 500 }} />
      </Container>
    </Link>
  );
};
